<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
        <div class="padding">
          <p>He scared me today. </p>
          <br>
<p>Children go through phases when they're little, when they fall down and scream for no reason, or walk into walls and insist that there was a door there earlier, but those are all physical things, they're expected, they happen from time to time. </p>
         <br>
 <p>He stood by the window for an hour while I was writing. I looked again at the piece of paper on my desk, the one that arrived there yesterday and was in two minds whether it was a joke, or another event. A reminder, maybe. I didn't write it, I'm certain of that. I might have written something similar, if I was more of a listener, but I'm not and I didn't. </p>
        <br>
  <p>I was staring at this sheet of paper, trying my best to remember where I'd heard the words before, whether it was in a voicering or an emarket and I couldn't place it. I knew the words, I could see them in the air, like a separating echo, but I didn't know where I'd stood when I first saw them.</p>
         <br>
 <p>Then that little sing-song voice, from across the room. </p>
          <p>- Mummy.</p>
          <p>= Oska, love, I'm writing. Can't you play in your room for a while?</p>
          <p>- Mummy, I want a drink.</p>
          <p>= Oska, there's a cup on the table with your drink in it. You asked for juice, there it is.</p>
          <p>- I finished that drink hours ago. And I finished my book.</p>
          <p>= You finished your book? Are you sure?</p>
          <p>- Mummy, I read every page and I wrote in the pages I was supposed to. </p>
          <p>- All of them?</p>
          <p>= All of them mummy. I thought and I remembered and I wrote it all down. </p>
          <p>- Well done baby bear. Now. Do you still want a drink?</p>
          <p>= Nope. Don't want a drink. Want a chalk please. </p>
          <p>= We'll go outside later and you can draw, is that alright? </p>
          <p>- Later?</p>
          <p>= No more than an hour. I'm going to finish this page. </p>
          <p>- Mummy?</p>
          <p>= Yes Oska?</p>
          <p>= In the book you're writing, the one with the city in it?</p>
          <p>- Yes bear?</p>
          <p>= That Oska, the one in the city, in your book.</p>
          <p>- _</p>
          <p>- Oska?</p>
          <p>= Will he grow up? </p>
          <p>- He's not you, love. He's in a book. </p>
          <p>= In a book isn't alive?</p>
          <p>- It's different. It's like all this things I know about you, all the things I love about you are in here, and when I wrote them here then they can stay, they can last forever. </p>
          <p>= Forever?</p>
          <p>- Forever and ever little bear. For as long as the world turns and the needle child stays in your dreams. That long.</p>
          <p>= And as long as the sea and the spiral descends mummy?</p>
          <p>- That long too. You can say the lament, bear? I didn't think you could remember all of the words.</p>
          <p>= Just funny ones mummy. The ones make me laugh.</p>
          <p>= Mummy, is daddy in your book too?</p>
          <p></p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p></p>
          <p></p><br>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'A Conversation'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
